module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainlogin_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "login_form"
  }, [_c('h1', [_vm._v("Administration Login")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _c('div', [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), (_vm.accountActive) ? _c('div', [_c('vue-form', {
    staticClass: "ui form loginForm row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v("Email or Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "required": "",
      "placeholder": "Enter email or phone number",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "email",
      "show": "$touched || $submitted"
    }
  }, [(!_vm.email) ? _c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Email or phone is a required field\n                    ")]) : _c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Email or phone is a required field\n                    ")])])], 1)]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.password),
    attrs: {
      "auto-label": ""
    }
  }, [_c('a', {
    staticClass: "fa fa-eye passwordView",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.showPassword
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "password",
      "name": "password",
      "placeholder": "Enter password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "password",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Password is a required field")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    }
  }, [_vm._v("\n                  Login\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "app-links",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.driverAppUrl
    }
  }, [_c('span', {
    staticClass: "c-pointer f-15"
  }, [_vm._v("Download Driver App")])]), _vm._v(" "), _c('a', {
    staticClass: "mt-10",
    attrs: {
      "href": _vm.surveyAppUrl
    }
  }, [_c('span', {
    staticClass: "c-pointer f-15"
  }, [_vm._v("Download Survey App")])])])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.accountActive && !_vm.emailSent) ? _c('div', {
    staticClass: "text-center col-md-4 col-md-offset-4"
  }, [_c('vue-form', {
    staticClass: "ui form",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendActivationEmail.apply(null, arguments)
      }
    }
  }, [_c('validate', {
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        email: _vm.emailValidator
      }
    }
  }, [_c('vue-form-input', {
    staticClass: "input-group",
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'email',
      "name": 'email',
      "placeholder": 'Email',
      "messages": {
        required: 'This field is required',
        email: 'Please input a valid email',
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-centered"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.formstate.$invalid
    }
  }, [_vm._v("\n                  Send Activation Email\n                ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.accountActive && _vm.emailSent) ? _c('div', {
    staticClass: "content-centered"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("\n                Proceed to Login\n              ")])])], 1) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "loginimg"
  }, [_c('img', {
    staticClass: "login logo",
    attrs: {
      "src": "/static/img/login_img.png"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6dd23d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/login/Login.vue
// module id = 2405
// module chunks = 1